import { render, staticRenderFns } from "./ShareBasketFormModal.vue?vue&type=template&id=0a2b0c98"
import script from "./ShareBasketFormModal.vue?vue&type=script&lang=js"
export * from "./ShareBasketFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports